import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { Drawer } from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';
import { Contents } from './Contents';
import { CopyLinkButton } from './components/CopyLinkButton';

export type ShareDrawerProps = {
  open: boolean;
  onClose: () => void;
  reportId: string;
  sharePath?: string;
  refetch: () => void | Promise<unknown>;
  onCloseDetailDrawer: () => void;
};

export const ShareDrawer: FC<ShareDrawerProps> = memo(
  ({ open, onClose, reportId, sharePath, refetch, onCloseDetailDrawer }) => {
    const containerRef = useGlobalContainerRef();
    const { t } = useTranslation();
    return (
      <Drawer
        visible={open}
        width={600}
        onClose={onClose}
        title={t('invoice_report_share.title')}
        button={<CopyLinkButton sharePath={sharePath} />}
        getContainer={containerRef}
        mask
      >
        <Contents
          reportId={reportId}
          refetch={refetch}
          onCloseDetailDrawer={onCloseDetailDrawer}
        />
      </Drawer>
    );
  }
);
ShareDrawer.displayName = 'ShareDrawer';
